// -----------------------------------------------------------------------------
// Allgemeine Funktionen für Videos
// -----------------------------------------------------------------------------

/**
 * Video mit Preview-Bild initialisieren
 *
 * @see https://www.labnol.org/internet/light-youtube-embeds/27941/
 * @see https://gist.github.com/CodeMyUI/f859685cbceba3acdf4a
 * @param id
 * @returns {Element}
 */
const initVideo = (id) => {
  const div = document.createElement('div');
  div.setAttribute('data-id', id);

  const thumbNode = document.createElement('img');
  thumbNode.src = '//img.youtube.com/vi/' + id + '/mqdefault.jpg';
  div.appendChild(thumbNode);

  const playButton = document.createElement('div');
  playButton.setAttribute('class', 'play');
  div.appendChild(playButton);
  div.onclick = function () {
    lazyLoadVideoIframe(this, id);
  };

  return div;
};

/**
 * Lazy-load Video-Iframe
 *
 * @see https://www.labnol.org/internet/light-youtube-embeds/27941/
 * @see https://gist.github.com/CodeMyUI/f859685cbceba3acdf4a
 * @param div
 * @param id
 */
const lazyLoadVideoIframe = (div, id) => {
  // Da das Vorschaubild nicht im Format 16:9 geliefert wird, muss der iFrame entsprechend dimensioniert werden
  const height = $(div).width() * 9 / 16;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('style', `height: ${height}`);
  iframe.setAttribute('src', `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`);
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
  div.parentNode.replaceChild(iframe, div);
};

export {
  initVideo
};
